import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "square",
      "stroke-width": "2",
      d: "m6.692 6.782 10.606 10.606m.001-10.606L6.692 17.388",
      "shape-rendering": "geometricPrecision"
    }, null, -1)
  ]))]))
}
export default { render: render }